import { taskListSchema, TasksApiResponse } from '@repo/shared/domain';
import { constructQuery } from '@repo/shared/helpers';
import { guardedClient as clientRequest } from '@repo/shared/helpers';

export const getGroupApprovals = async (
	groupId: string,
	params?: { page?: number; sort?: string },
): Promise<TasksApiResponse> => {
	const query = constructQuery({
		page: params?.page,
		sort: params?.sort,
		groupId,
	});
	const { body } = await clientRequest.get<undefined, TasksApiResponse>(`/api/tasks/approvals/view-only?${query}`, {
		schema: taskListSchema,
	});
	return body;
};

export const getUserApprovals = async (
	userId: string,
	params?: { page?: number; sort?: string },
): Promise<TasksApiResponse> => {
	const query = constructQuery({
		page: params?.page,
		sort: params?.sort,
		userId,
	});
	const { body } = await clientRequest.get(`/api/tasks/approvals/view-only?${query}`, {
		schema: taskListSchema,
	});
	return body;
};
